import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: {},
  isFetching: false,
  error: false
}

export const photoVignette = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.POST_PHOTO_VIGNETTE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.POST_PHOTO_VIGNETTE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.POST_PHOTO_VIGNETTE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: {
          ...state.data,
          [action.id]: action.data
        }
      }
    case actionTypes.SET_PHOTO_VIGNETTE_ALL:
      return {
        ...state,
        data: action.data
      }
    case actionTypes.CLEAR_PHOTO_VIGNETTE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: null
        }
      }
    case actionTypes.CLEAR_PHOTO_VIGNETTE_ALL:
      return {
        ...state,
        data: {}
      }
    default:
      return state;
  }
}
